import { createContext, useContext } from "react";

export const AssortmentContext = createContext({});

export function useAssortmentContext() {
    return useContext(AssortmentContext);
}
